module.exports = __webpack_public_path__ + "logo-nextbank_8e4da5926c8c092c33c758d355954754.svg";